module.exports = __webpack_public_path__ + "4f2c0040a8eb6491322a3028734b9d06.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/progressive_2023_chart.png
// module id = 1723
// module chunks = 0